const PLUGIN_ID = 'content-manager';

const PERMISSIONS = [
  'plugin::content-manager.explorer.create',
  'plugin::content-manager.explorer.read',
  'plugin::content-manager.explorer.update',
  'plugin::content-manager.explorer.delete',
  'plugin::content-manager.explorer.publish',
];

export { PLUGIN_ID, PERMISSIONS };
